
(function($){
  $(document).on( 'ready', function(){
    // $('body').css('margin-top', $('header.header').outerHeight());
  });

  window.addEventListener("orientationchange", function() {
    // Announce the new orientation number
    // $('body').css('margin-top', $('header.header').outerHeight());
  }, false);

})(jQuery);
